import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Form,
  Container,
  Button,
  FormGroup,
  Alert,
  Image,
} from "react-bootstrap";
import { connect } from "react-redux";
import { isEmpty, isNumber } from "lodash";
import Spinner from "react-bootstrap/Spinner";
import "jspdf-autotable";
import Swal from "sweetalert";
import { addFlavors } from "./Flavour.action";
import { setHeading } from "../../../accounts/account.actions";

const AddFlavour = (props) => {
  const [flavors, setFlavors] = useState("");
  const [flavorsDesc, setFlavorsDesc] = useState("");
  const [visibleAlert, setAlertVisible] = useState(false);
  const [dangerVisibleAlert, setDangerVisibleAlert] = useState(false);

  const handleVisible = (msg) => {
    setAlertVisible(true);
    setTimeout(() => {
      setAlertVisible(false);
    }, 9000);
    Swal({
      title: "Success",
      text: msg,
      icon: "success",
      button: "Ok",
    });
  };

  const handleDangerVisible = (err) => {
    setDangerVisibleAlert(true);
    setTimeout(() => {
      setDangerVisibleAlert(false);
    }, 9000);
    Swal({
      title: "Error",
      text: err,
      icon: "error",
      button: "Ok",
    });
  };
  function uploadFlavors() {
    props.addFlavors(
      {
        flavourName: flavors,
        flavourDesc: flavorsDesc,
      },
      handleVisible,
      handleDangerVisible
    );
    setFlavors("");
    setFlavorsDesc("");
  }
  useEffect(() => {
    props.setHeading("Add Flavour");
  }, []);
  return (
    <>
      {props.isAddingFlavors ? (
        <div className="loader-div">
          <Spinner
            variant="primary"
            animation="grow"
            size="xl"
            role="status"
            aria-hidden="true"
          />
        </div>
      ) : (
        <Container fluid>
          <div className="main">
            <div>
              <Form>
                <Row>
                  <Col lg="6" md="6" xs="6">
                    <Form.Group className="mb-3" controlId="garana">
                      <Form.Label>
                        <b>Flavor Name *</b>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Flavor Name...."
                        onChange={(e) => setFlavors(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg="6" md="6" xs="6">
                    <Form.Group className="mb-3" controlId="garana">
                      <Form.Label>
                        <b>Flavor Description :</b>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        value={flavorsDesc}
                        placeholder="Flavor Description...."
                        onChange={(e) => setFlavorsDesc(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <div className="sendDiv">
                  {isEmpty(flavors) ? (
                    <Button
                      disabled
                      style={{
                        marginLeft: "2%",
                        color: "white",
                        width: "20%",
                        backgroundColor: "#1976d2",
                        border: "1px solid #1976d2",
                      }}
                    >
                      Save
                    </Button>
                  ) : (
                    <Button onClick={uploadFlavors}>Save</Button>
                  )}
                </div>
              </Form>
            </div>
          </div>
        </Container>
      )}
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    addFlavors: (data, handleVisible, handleDangerVisible) =>
      dispatch(addFlavors(data, handleVisible, handleDangerVisible)),
    setHeading: (data) => dispatch(setHeading(data)),
  };
};
const mapStateToProps = (state, ownProps) => ({
  flavorsList: state.FlavourReducer.flavorsList,
  isAddingFlavors: state.FlavourReducer.isAddingFlavors,
});

export default connect(mapStateToProps, mapDispatchToProps)(AddFlavour);
